// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__2NTz3","spin":"Spinner_spin__21t8N"};